import { render, staticRenderFns } from "./GlobalCard.vue?vue&type=template&id=1bba44ba&scoped=true"
import script from "./GlobalCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./GlobalCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GlobalCard.vue?vue&type=style&index=0&id=1bba44ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bba44ba",
  null
  
)

export default component.exports